module.exports = __webpack_public_path__ + "static/LOGO 4-30311c8aaf5182dcbbc4f0e86b466d10.png";